import _objectWithoutProperties from "/home/runner/work/notes/notes/.layouts/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _taggedTemplateLiteral from "/home/runner/work/notes/notes/.layouts/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _excluded = ["children"];

var _templateObject;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { COMMON, TYPOGRAPHY } from './constants';
var GlobalStyle = createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  * { box-sizing: border-box; }\n  body { margin: 0; }\n  table { border-collapse: collapse; }\n  \n  [role=\"button\"]:focus:not(:focus-visible):not(.focus-visible),\n  [role=\"tabpanel\"][tabindex=\"0\"]:focus:not(:focus-visible):not(.focus-visible),\n  button:focus:not(:focus-visible):not(.focus-visible),\n  summary:focus:not(:focus-visible):not(.focus-visible),\n  a:focus:not(:focus-visible):not(.focus-visible) {\n    outline: none;\n    box-shadow: none;\n  }\n\n  [tabindex=\"0\"]:focus:not(:focus-visible):not(.focus-visible),\n  details-dialog:focus:not(:focus-visible):not(.focus-visible) {\n    outline: none;\n  }\n"])));
var Base = styled.div.withConfig({
  displayName: "BaseStyles__Base",
  componentId: "qvuaww-0"
})(["", ";", ";"], TYPOGRAPHY, COMMON);

function BaseStyles(props) {
  var children = props.children,
      rest = _objectWithoutProperties(props, _excluded); // load polyfill for :focus-visible


  require('focus-visible');

  return /*#__PURE__*/React.createElement(Base, _extends({}, rest, {
    "data-portal-root": true
  }), /*#__PURE__*/React.createElement(GlobalStyle, null), children);
}

BaseStyles.displayName = "BaseStyles";
BaseStyles.defaultProps = {
  color: 'text.primary',
  fontFamily: 'normal',
  lineHeight: 'default'
};
export default BaseStyles;